import React, {ReactNode} from 'react'
import {TableRowName} from '../../../styledComponents/adminPage/Table'
import PPRadioGroup from '../../shared/forms/PPRadioGroup'
import {AVAILABLE_OR_NOT} from '../../../CodeMaster'
import {Nullable} from '../../../app/TypeHelpers'
import PPNumericField from '../../shared/forms/PPNumericField'
import {HKConstants} from '../../../HKConstants'
import {LeftRowFlexContainer} from '../../../styledComponents/FlexComponents'
import {Box, TableCell, TableRow} from '@mui/material';
import {StyledLabel} from '../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {numberOrNull, stringOrEmpty} from '../../../stringHelper/stringHelpers'
import {ReservationSettings} from './ReservationSettingsComponent'
import equal from 'fast-deep-equal'
import EventEmitterExAdmin from '../../shared/pageBaseComponents/EventEmitterExAdmin'

interface LotterySettings {
    lotteryAvailability: AVAILABLE_OR_NOT
    lotteryPriority: Nullable<number>
}

interface Props extends LotterySettings {
    handleReservationSettingsChange: (reservationSettings: Partial<ReservationSettings>) => void
    eventEmitter: EventEmitterExAdmin
}

class LotterySettingsComponent extends React.Component<Props> {

    static displayName: string = 'LotterySettingsComponent'

    constructor(props: Readonly<Props>) {
        super(props)

        this.handleLotteryAvailabilityChange = this.handleLotteryAvailabilityChange.bind(this)
        this.handleLotteryPriorityChange = this.handleLotteryPriorityChange.bind(this)
    }

    shouldComponentUpdate(nextProps: Readonly<Props>): boolean {
        return !(this.props === nextProps || equal(this.props, nextProps))
    }

    handleLotteryAvailabilityChange(event: React.ChangeEvent<HTMLInputElement>): void {
        const {handleReservationSettingsChange, eventEmitter, ...rest} = this.props
        const lotteryAvailability: AVAILABLE_OR_NOT =
            AVAILABLE_OR_NOT.codeToEnumConstants(`${event.target.value}`)
        handleReservationSettingsChange({
            ...rest,
            lotteryAvailability: lotteryAvailability,
        })
    }

    handleLotteryPriorityChange(event: React.ChangeEvent<HTMLInputElement>): void {
        const {handleReservationSettingsChange, eventEmitter, ...rest} = this.props
        handleReservationSettingsChange({
            ...rest,
            lotteryPriority: numberOrNull(event.target.value),
        })

    }

    renderLotteryPriority(): ReactNode {
        if (this.props.lotteryAvailability === AVAILABLE_OR_NOT.UNAVAILABLE) {
            return null
        }
        return (<>
            <Box marginRight={'50px'}/>
            <label>
                <LeftRowFlexContainer>
                    <PriorityLabel>優先度</PriorityLabel>
                    <LotteryPriority
                        InputProps={{
                            inputProps: {
                                min: 0,
                                max: HKConstants.VMN.FAC.MAX_PRIORITY_VALUE_OF_RESERVATIONS,
                            },
                        }}
                        placeholder={`${HKConstants.VMN.FAC.DEFAULT_PRIORITY_VALUE_OF_RESERVATIONS}`}
                        value={stringOrEmpty(this.props.lotteryPriority)}
                        onChange={this.handleLotteryPriorityChange}
                    />
                </LeftRowFlexContainer>
            </label>
        </>)
    }

    render(): ReactNode {
        return (<>
            <TableRow>
                <TableRowName>抽選設定</TableRowName>
                <TableCell>
                    <LeftRowFlexContainer>
                        <PPRadioGroup
                            row
                            data={AVAILABLE_OR_NOT.values()}
                            value={this.props.lotteryAvailability.value}
                            eventKeys={['lotteryAvailability']}
                            eventEmitter={this.props.eventEmitter}
                            onChange={this.handleLotteryAvailabilityChange}
                        />
                        {this.renderLotteryPriority()}
                    </LeftRowFlexContainer>
                </TableCell>
            </TableRow>
        </>)
    }
}

const PriorityLabel: StyledLabel = styled.label`
  margin-right: 20px;
`

const LotteryPriority = styled(PPNumericField)`
  width: 60px;
`

export default LotterySettingsComponent
